<template>
  <div v-if="!isLoading" class="container-fluid new_Header">
    <div class="row pt-3">
      <div class="col">
        <nav>
          <ol class="breadcrumb">
            <li class="breadcrumb-item mx-1"><router-link  to="/">{{$t('propReservationDetails.breadcrumb_1')}}</router-link></li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="breadcrumb-item mx-2">
              <router-link to="/myreservations">
                {{$t('propReservationDetails.breadcrumb_2')}}
              </router-link>
            </li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="breadcrumb-item mx-1 almarai-bold" aria-current="page">
              {{$t('propReservationDetails.breadcrumb_3')}}
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <div class="container pt-3">
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <mainloader v-if="isLoading" />
    <div v-else class="row pt-3">
      <div class="col">
        <div class="row retrieve">
          <div class="col-12 col-md-8 content-center">
            <div class="fonttext-14 almarai-regular d-flex">
              <img src="/assets/images/icons/calendar.png" class="mx-2" alt="">
              {{moment(row.row.createdAt).format('lll a')}}
            </div>
          </div>
          <div class="col-10 col-md-3">
            <div class="bg-color-beige">{{reservationStatus[row.row.status]}}</div>
          </div>
          <div class="col-8 col-md-2 btn-bill my-2" v-if="billUrl">
            <a :href="BASE_URL+billUrl" target="_blank" type="application/pdf">
              <div>
                <img src="/assets/images/icons/receipt-text.png" class="max-22" alt="">
                <span class="mx-2">{{$t('invoiceDetails')}}</span>
              </div>
            </a>
          </div>
        </div>

        <!-- <div class="row pt-3">
          <div class="col">
            <div class="almarai-bold">{{$t('previewdetails.title_1')}}</div>
          </div>
        </div> -->

        <div class="row pt-5">
          <div class="col-12 col-md-3 mb-3">
            <div class="card card-border m-auto">
              <div class="card-body padding-8">
                <div class="row statusBar pt-2 position-R">
                  <div class="col-auto tag-style">
                    <span>{{ row.row.Property.PropertyType.name}}</span>
                  </div>
                  <div class="col-auto tag-style">
                    <span>{{row.statusChoices[row.row.Property.status]}}</span>
                  </div>
                  <div class="col-auto tag-style">
                    <span class="">{{(row.purpose == 'for_rent') ? $t('rent') : (row.purpose == 'for_sale') ? $t('sale')  : $t('investment') }}</span>
                  </div>
                </div>
                <swiper v-if="row.row.Property.mediaFiles.length" class="text-center" :modules="[Pagination, Navigation]" :pagination="{ clickable: true }" :navigation="false">
                  <swiper-slide v-for="(val, index) in row.row.Property.mediaFiles" :key="index">
                    <img :src="MEDIA_URL+val.thumbnail" alt="Slide Image" class="img-fluid br-radius" />
                  </swiper-slide>
                </swiper>
                <div v-else>
                  <placeHolder />
                </div>
                <div class="almarai-regular">{{ row.row.Property.title }}</div>
                <div class="pt-2 d-flex">
                  <i class="fa-solid fa-location-dot gray-color"></i>
                  <div class=" mx-2 gray-color fonttext-14">{{row.row.Property.Neighborhood.name}}</div>
                  <div class="gray-color fonttext-14">{{row.row.Property.City.name}}</div>
                </div>
                <hr class="border-color-w">
                <div class="row end-card space">
                  <div class="col">
                    <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
                    <span class="green-color-F almarai-bold">{{ row.row.Property.price }}</span>
                    <!-- <span class="mx-1 green-color-F">{{$t('currency')}}</span> -->
                  </div>
                  <div class="col-auto content-center">
                    <span><img :src="MEDIA_URL+row.countedIcons.roomsCount.path" alt="" class="max-width-28"></span>
                    <span class="numbers">{{ row.row.Property.roomsCount }}</span>
                  </div>
                  <div class="col-auto border_Icons">
                    <span><img :src="MEDIA_URL+row.countedIcons.bathrooms.path" alt="" class="max-width-28"></span>
                    <span class="numbers">{{ row.row.Property.bathrooms }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--begin:location-->
        <div class="row pt-3" v-if="!isLoading && row.row.Property.latitude !='0.000000' && row.row.Property.longitude!='0.000000'">
          <div class="col">
            <div class="almarai-bold py-2">{{$t('previewdetails.title_5')}}</div>
            <div ref="myMap" style="width: 100%; height: 350px;"></div>
          </div>
        </div>
      </div>
      <!--end:location-->
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation } from "swiper/modules";
import { mapGetters } from "vuex";
import moment from 'moment';
export default {
  name: "propReservationDetails",
  data(){
    return {
      propReservationId: this.$route.params.id,
      hasError: false,
      message: "",
      errorNumber: 0,
      isLoading: true,
      row: {},
      loading: false,
      reservationStatus: {},
      userLang: 'ar',
      billUrl: null,
    }
  },
  setup() {
    return {
      Pagination,
      Navigation,
    };
  },
  components: { Swiper, SwiperSlide },
  computed:{
    ...mapGetters(['MEDIA_URL','BASE_URL'])
  },
  methods: {
    getDataPropReservation(){
      this.hasError = false;
      this.$http.get('/api/propReservation/get/'+this.propReservationId).then(res => {
        // console.log(res);
        // this.Agent = res.data.row.Property.Agent ?? {};
        this.row = res.data;
        this.reservationStatus = res.data.reservationStatus;
        this.initialGoogleMap();
        this.getBill();
        window.scroll(0,0);
        this.isLoading = false;
      }).catch(err => {
        // console.log(err);
        this.isLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      })
    },

    initMap(){
      if (!this.$refs.myMap) {
        setTimeout(() => this.initMap(), 200);
        return;
      }
      if (!window.google) {
        console.error("Google Maps API is not loaded.");
        return;
      }
      // Initialize Map
      this.map = new google.maps.Map(this.$refs.myMap, {
        center: { 
          lat: (this.row.row.Property.latitude) ? parseFloat(this.row.row.Property.latitude) : 24.7136, 
          lng: (this.row.row.Property.longitude) ? parseFloat(this.row.row.Property.longitude) : 46.6753 
        },
        zoom: 8,
      });

      // Create a Marker
      this.marker = new google.maps.Marker({
        position: { 
          lat: (this.row.row.Property.latitude) ? parseFloat(this.row.row.Property.latitude) : 24.7136, 
          lng: (this.row.row.Property.longitude) ? parseFloat(this.row.row.Property.longitude) : 46.6753 
        },
        map: this.map,
        draggable: false, // Allow dragging the marker
      });
    },

    initialGoogleMap(){
      if (!window.google) {
        const script = document.createElement("script");
        script .src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyCmKIguViZj4DtgCcT2Wv8pstx0ynuHMWg&loading=async&libraries=places&callback=initMap`
        script.async = true;
        document.head.appendChild(script);
        window.initMap = this.initMap;
      } else {
        this.initMap();
      }
    },
    methodPayment(){
      document.getElementById('selectPayment').click();
    },

    getBill(){
      this.$http.get('/api/bills/PropReservations/'+this.propReservationId).then(res => {
        if(res.data.url)
        this.billUrl = res.data.url
      }).catch(() => {});
    },

    moment,
    formatDate(){
      if(this.userLang == 'ar'){
        moment.locale(this.formatedDate);
      }else{
        moment.locale(this.fallbackLang);
      }
      this.nowTime = new Date();
      this.hours = this.nowTime.getHours().toString().padStart(2, '0');
      this.minutes = this.nowTime.getMinutes().toString().padStart(2, '0');
      this.formattedTime = `${this.hours}:${this.minutes}`;
      // console.log(this.formattedTime);
    },
  },
  created(){
    this.getDataPropReservation();
    this.userLang = localStorage.getItem('lang') ?? 'ar';
  }
}
</script>